export const equifaxData=

{
  
}





export const EV2MobileVerify = 
// {
//     "status": {
//         "code": 200,
//         "type": "success",
//         "message": "Details fetched successfully."
//     },
//     "message": "Details fetched successfully.",
//     "data": {
//         "name": "",
//         "dob": "10-08-2000",
//         "gender": "Male",
//         "pan": "",
//         "email": "",
//         "address": [
//             {
//                 "first_line_of_address": "BHARAMPURA THANA PATHAK HOUSE",
//                 "second_line_of_address": "MUZAFFARPUR 221 BIHAR",
//                 "third_line_of_address": null,
//                 "city": null,
//                 "state": "BIHAR",
//                 "postal_code": "842001",
//                 "country_code": "IB"
//             },
//         ],
//         "message": "success"
//     }
// }

{
    "status": {
        "code": 200,
        "type": "success",
        "message": "No records were found matching the provided details in this bureau. Please try again using different information or consider checking with another bureau."
    },
    "message": "No records were found matching the provided details in this bureau. Please try again using different information or consider checking with another bureau.",
    "data": {
        "http_response_code": 200,
        "client_ref_num": "LZaMXOFHJU5XsEhw",
        "request_id": "7de11430-c9c6-4e95-a007-1822f52e28b8",
        "result_code": 103,
        "message": "name not found",
        "result": null,
        "idspay_message": "No records were found matching the provided details in this bureau. Please try again using different information or consider checking with another bureau."
    }
}




export const equifaxDataError= 
//  {
//             "data": {
//               "client_id": "credit_report_v2_HaeavnwRhwStmdSJspPV",
//               "pan": null,
//               "id_number": "**7930",
//               "id_type": "aadhaar",
//               "mobile": "8637535656",
//               "gender": "male",
//               "name": "SUBHAM GHOSH",
//               "credit_score": "",
//               "credit_report": [],
//               "credit_report_link": ""
//             },
//             "status_code": 422,
//             "success": false,
//             "message": "Mobile does not match with credit file, matched mobile: XXXXX62889",
//             "message_code": "mobile_not_match"
//           }
      
{
    "status": {
        "code": 500,
        "type": "error",
        "message": "Credit score request processing failed."
    },
    "message": "Credit score request processing failed.",
    "error": {
        "client_id": "credit_report_v2_fEGmatawqaDiieXSaNZo",
        "pan": null,
        "id_number": "********4174",
        "id_type": "aadhaar",
        "mobile": "9162484365",
        "gender": "male",
        "name": "MANORMA  DEVI",
        "credit_score": "",
        "credit_report": [],
        "credit_report_link": "",
        "credit_report_message": {
            "message": "Verification Failed.",
            "message_code": "verification_failed"
        }
    }
}

// {
//   "data": {
//     "client_id": "credit_report_v2_ItleupgjsBAtwlfgGxbn",
//     "pan": null,
//     "id_number": "**4174",
//     "id_type": "aadhaar",
//     "mobile": "9162484365",
//     "gender": "male",
//     "name": "MANORMA DEVI",
//     "credit_score": "",
//     "credit_report": [],
//     "credit_report_link": ""
//   },
//   "status_code": 422,
//   "success": false,
//   "message": "Verification Failed.",
//   "message_code": "verification_failed"
// }







export const CreditScoreData = 
// {
//     "status": {
//         "code": 200,
//         "type": "success",
//         "message": "Details fetched successfully."
//     },
//     "message": "Details fetched successfully.",
//     "data": {
//         "http_response_code": 200,  
//         "client_ref_num": "YkV3v82gHvUXxs1B",
//         "request_id": "54c30fd3-46dc-4437-999e-bc99f8fe59b5",
//         "result_code": 102,
//         "message": "no record found",
//         "result": null
//     }
// }



{
    "status": {
        "code": 200,
        "type": "success",
        "message": "Details fetched successfully."
    },
    "message": "Details fetched successfully.",
    "data": {
        "name": "",
        "dob": "",
        "gender": "Male",
        "pan": "",
        "email": "",
        "address": [
            {
                "first_line_of_address": "BHARAMPURA THANA PATHAK HOUSE",
                "second_line_of_address": "MUZAFFARPUR 221 BIHAR",
                "third_line_of_address": null,
                "city": null,
                "state": "BIHAR",
                "postal_code": "842001",
                "country_code": "IB"
            }

        ],
        "score": "",
        "message": "success"
    }
}



export const CreditScoreDataPrefill = 

{
    "status": {
        "code": 200,
        "type": "success",
        "message": "Request processed successfully."
    },
    "message": "Request processed successfully.",
    "data": {
        "name": "RAVINDRA KUMAR",
        "mobile": "9354186580",
        "personal_info": {
            "full_name": "RAVINDER KUMAR ",
            "dob": "1991-01-01",
            "gender": "Male",
            "total_income": null,
            "occupation": null,
            "age": "35"
        },
        "phone_info": [
            {
                "reported_date": "2025-09-30",
                "type_code": "H",
                "number": "9354186580"
            },
            {
                "reported_date": "2025-10-31",
                "type_code": "M",
                "number": "9354186580"
            },
            {
                "reported_date": "2021-08-31",
                "type_code": "M",
                "number": "7065661457"
            }
        ],
        "address_info": [
            {
                "address": "HOUSE NO 51 NANGLOI NILOTHI GAON WEST DELHI 5112 DELHI",
                "state": "DL",
                "type": null,
                "postal": "110041",
                "reported_date": "2025-10-31"
            },
            {
                "address": "HOUSE NO 51 NILOTHI GAON MUMBAI",
                "state": "DL",
                "type": "Primary",
                "postal": "110041",
                "reported_date": "2025-09-30"
            },
            {
                "address": "HOUSE NO 51 NILOTHI GAON MUMBAI",
                "state": "DL",
                "type": null,
                "postal": "110041",
                "reported_date": "2024-12-15"
            },
            {
                "address": "HOUSE NO-51 NILOTHI GAON PRADHAN MARKET NEW DELHI",
                "state": "DL",
                "type": "Primary",
                "postal": "110041",
                "reported_date": "2021-08-31"
            },
            {
                "address": "STREET HAWKER NILOTI GAON PARADHAN MARKET NEW DELHI",
                "state": "DL",
                "type": "Office",
                "postal": "110041",
                "reported_date": "2021-08-31"
            }
        ],
        "email_info": [],
        "identity_info": {
            "identity_info": [
                {
                    "identity_info": "HEEPK3431L"
                }
            ],
            "passport_number": [],
            "driving_license": [],
            "voter_id": [],
            "aadhaar_number": [],
            "ration_card": [],
            "other_id": [
                {
                    "id_number": "10050850926793"
                }
            ]
        },
        "reference": "17665805819187249331",
        "pdf_url": "https://apiuser.idspay.in/credit-report-pdf?reference=694be168c0a4b&type=SVC0144"
    }
}




